<template>
    <div v-loading.fullscreen.lock="loading">
        <el-row :gutter="20" style="margin-bottom: 20px;" v-if="currentview == 'senarai'">
            <el-col :span="1"><el-button type="plain" icon="el-icon-upload2" size="mini" plain @click="showUpload">Upload Excel</el-button></el-col>
        </el-row>
        <upload v-if="currentview == 'upload'"></upload>
        <el-card shadow="always" :body-style="{ padding: '20px' }" style=" width: 400px; " v-if="currentview == 'senarai'">
            <div slot="header" style="text-align: left;">
                <span>Carian</span>
            </div>
            <el-form :model="carian" ref="carian" label-width="90px" :inline="false" size="mini">
                <el-form-item label="Nama">
                        <el-input v-model="carian.nama" placeholder="" size="normal" clearable></el-input>
                </el-form-item>
                <el-form-item label="PG Code">
                        <el-input v-model="carian.pgcode" placeholder="" size="normal" clearable></el-input>
                </el-form-item>
                <el-form-item label="Web ID">
                        <el-input v-model="carian.webid" placeholder="" size="normal" clearable></el-input>
                </el-form-item>
                <el-form-item label="Telefon">
                        <el-input v-model="carian.tel" placeholder="" size="normal" clearable></el-input>
                </el-form-item>
                <el-form-item label="Emel">
                        <el-input v-model="carian.emel" placeholder="" size="normal" clearable></el-input>
                </el-form-item>
            </el-form>
        </el-card>
        
        <el-table :data="displayData"  stripe ref="tblSenarai" empty-text="Loading data.." @sort-change="sortChanges" style=" padding-top: 50px; margin-bottom: 20px;" v-if="currentview == 'senarai'">
            
            <el-table-column label="#" type="index" :index="pagination.page * pagination.pageSize - pagination.pageSize + 1" width="100"></el-table-column>
            <el-table-column type="expand">
                <template slot-scope="props">
                    <el-row>
                        <el-col :span="1">
                            &nbsp;
                        </el-col>
                        <el-col :span="2">
                            <div class="grid-content bg-purple-dark">
                                <el-avatar shape="circle" :size="100" :src="$webURL + '/assets/img/dealers/'+props.row.webid+'.jpg?v='+props.row.version"></el-avatar>
                            </div>
                        </el-col>
                        <el-col :span="21">
                            <div class="grid-content bg-purple-dark">                            
                                <p>Ayat Intro: {{ props.row.ayatintro }}</p>
                                <p v-if="props.row.website">Website: {{ props.row.website }}</p>
                                <p v-if="props.row.fb"><font-awesome-icon :icon="['fab', 'facebook']" size="lg" :style="{color: '#3b5998'}"></font-awesome-icon> {{ props.row.fb }}</p>
                                <p v-if="props.row.ig"><font-awesome-icon :icon="['fab', 'instagram']" size="lg" :style="{color: '#c32aa3'}"></font-awesome-icon> {{ props.row.ig }}</p>
                                <p v-if="props.row.tw"><font-awesome-icon :icon="['fab', 'twitter']" size="lg" :style="{color: '#1da1f2'}"></font-awesome-icon> {{ props.row.tw }}</p>
                                <p v-if="props.row.yt"><font-awesome-icon :icon="['fab', 'youtube']" size="lg" :style="{color: '#ff0000'}"></font-awesome-icon> {{ props.row.yt }}</p>
                                <p v-if="props.row.tg"><font-awesome-icon :icon="['fab', 'telegram']" size="lg" :style="{color: '#0088cc'}"></font-awesome-icon> {{ props.row.tg }}</p>
                                <p v-if="props.row.tt"><font-awesome-icon :icon="['fab', 'tiktok']" size="lg" :style="{color: '#010101'}"></font-awesome-icon> {{ props.row.tt }}</p>
                            </div>
                        </el-col>
                    </el-row>
                </template>
            </el-table-column>
            <el-table-column prop="webid" label="Web ID" width="100"></el-table-column>
            <el-table-column prop="fullname" label="Nama" width="400"></el-table-column>
            <el-table-column prop="pgcode" label="PG Code" width="120"></el-table-column>
            <el-table-column prop="tel" label="Telefon" width="130"></el-table-column>
            <el-table-column prop="emel" label="Emel" width="200"></el-table-column>
            <el-table-column prop="jenis" label="Jenis" width="100"></el-table-column>
            <el-table-column prop="tarikh_wujud" label="Tarikh Wujud" width="200" sortable="custom">
                <template slot-scope="x">
                    {{ x.row.tarikh_wujud | tarikh }}
                </template>
            </el-table-column>
            <el-table-column prop="tarikh_tamat" label="Tarikh Tamat" width="200" sortable="custom">
                <template slot-scope="x">                    
                    <el-link type="primary" :underline="false" @click="btnDlgTkhTamat(x.row)">{{ x.row.tarikh_tamat | tarikh }}</el-link>                    
                </template>
            </el-table-column>
            <el-table-column prop="affiliate" label="Affiliate" width="100"></el-table-column>
            <el-table-column label="Aktif ?" width="80">
                <template slot-scope="x">
                    <el-switch :value="!!x.row.active" :active-value="true" :inactive-value="false" @change="activate(x,this)"></el-switch>                    
                </template>
            </el-table-column>
            <el-table-column label="Hapus ?" width="80">
                <template slot-scope="x">
                    <el-popconfirm
                    confirm-button-text='Hapus'
                    cancel-button-text='Tidak'
                    icon="el-icon-info"
                    icon-color="red"
                    title="Anda pasti untuk hapus butiran tersebut?"
                    @confirm="btnHapus(x)"
                    >
                        <el-button slot="reference" type="danger" size="small" circle icon="el-icon-delete"></el-button>                                       
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
        background
        layout="prev, pager, next"
        @current-change="currentChange"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        v-if="currentview == 'senarai'">
        </el-pagination>
        <el-dialog
            title="Tarikh Tamat"
            :visible.sync="dlgTkhTamat.show"
            width="300px">
            <el-date-picker v-model="dlgTkhTamat.date" type="date" size="normal" placeholder="Pilih tarikh tamat baharu" format="dd/MM/yyyy" value-format="yyyy-MM-dd hh:mm:ss">
            </el-date-picker>
            
            <span slot="footer">
                <el-button @click="dlgTkhTamat.show = false">Batal</el-button>
                <el-button type="primary" @click="btnDlgTkhTamat(2)">OK</el-button>
            </span>
        </el-dialog>
        
        
    </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import Upload from '@/views/Upload.vue'
export default {
    name: 'Registration',
    data() {
        return { 
            currentview: 'senarai',  
            senarai: [],
            carian: {},
            loading: false,
            sort: {
                prop: 'tarikh_wujud',
                order: 'descending'
            },
            dlgTkhTamat: {
                show: false,
                date: '',
                id: null
            },
            pagination: {
                pageSize: 25,
                page: 1,
                total: 0
            }
        }
    },
    computed: {
        isAdmin: function() {
            return this.$store.getters.isAdmin
        },
        displayData() {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.pagination.total = this.senarai.length
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            let data =  this.senarai.sort((a,b) => {
                let _this = this
                if(this.sort.order == 'descending') {
                    return a[_this.sort.prop] < b[_this.sort.prop] ? -1 : (a[_this.sort.prop] > b[_this.sort.prop]) ? 1 : 0
                }
                else {
                    return a[_this.sort.prop] > b[_this.sort.prop] ? -1 : (a[_this.sort.prop] < b[_this.sort.prop]) ? 1 : 0
                }
            })
            
            //CARIAN
            if(this.carian.nama) {
                data = data.filter( user => user.fullname.toLowerCase().search(this.carian.nama.toLowerCase()) != -1)
            }
            if(this.carian.pgcode) {
                data = data.filter( user => user.pgcode.toLowerCase().search(this.carian.pgcode.toLowerCase()) != -1 )
            }
            if(this.carian.webid) {
                data = data.filter( user => user.webid.toLowerCase().search(this.carian.webid.toLowerCase()) != -1 )
            }
            if(this.carian.tel) {
                data = data.filter( user => user.tel.toLowerCase().search(this.carian.tel.toLowerCase()) != -1 )
            }
            if(this.carian.emel) {
                data = data.filter( user => user.emel.toLowerCase().search(this.carian.emel.toLowerCase()) != -1 )
            }

            return data.slice(this.pagination.pageSize * this.pagination.page - this.pagination.pageSize, this.pagination.pageSize * this.pagination.page);
        }
    },
    methods: {
        activate(x){
            this.senarai.find( i => i.id == x.row.id).active = this.senarai.find( i => i.id == x.row.id).active ? 0 : 1
            let user = this.senarai.find( i => i.id == x.row.id)
            axios.put('admin', user)
            .then(() => {                
                this.$message({
                    message: 'Status akaun ' + user.fullname + ' telah ' + (user.active ? 'diakifkan' : 'dinyahaktifkan'),
                    type: 'success'
                });
            })
            .catch(err => {
                console.log(err);
            })
        },
        btnDlgTkhTamat(n) {
            if(typeof(n) === 'object') {
                this.dlgTkhTamat.id = n.id
                this.dlgTkhTamat.date = n.tarikh_tamat
                this.dlgTkhTamat.show = true
            }
            else {
                this.senarai.find( i => i.id == this.dlgTkhTamat.id).tarikh_tamat = this.dlgTkhTamat.date
                let user = this.senarai.find( i => i.id == this.dlgTkhTamat.id)
                axios.post('admin', user)
                .then(() => {
                    this.dlgTkhTamat.show = false
                    this.$message({
                        message: 'Butiran Tarikh Tamat berjaya dikemaskini bagi ' + user.fullname,
                        type: 'success'
                    });
                })
                .catch(err => {
                    console.log(err);
                })
            }
        },
        btnHapus(x) {
            // this.senarai.splice(x.$index, 1)
            let user = this.senarai.splice(this.senarai.findIndex( s => s.id == x.row.id), 1)
            axios.delete('admin', { data: {id : x.row.id }})
            .then(() => {
                                       
                this.$message({
                    message: 'Rekod ' + user[0].fullname + ' tersebut telah dihapuskan',
                    type: 'success'
                });

            })
            .catch(err => {
                console.log(err);
            })
            
        },
        currentChange(val) {
            this.pagination.page = val
        },
        sortChanges({ prop, order }) {
            this.sort = { prop, order }
        },
        showUpload() {
            this.currentview = 'upload'
        }
    },
    created() {   
        if(!this.isAdmin) {
            this.$router.push('/')
        }

        this.loading = true
        axios('admin')
        .then( resp => {
            this.senarai = resp.data.sort((a,b) => new Date(b.tarikh_tamat) - new Date(a.tarikh_tamat))
            this.loading = false
        })
        .catch( () => {
            this.$store.dispatch('LogOut');
            this.$router.push('login')
            this.loading = false
        })
    },
    filters: {
        tarikh(x) {
            return moment(x,'yyyy-MM-DD hh:mm:ss').format('DD/MM/yyyy')
        }
    },
  components: {
    Upload
  }
}
</script>
